<template>
    <div v-loading="loading">
      <el-form :model="formData" :rules="rules" ref="formData" label-width="100px" class="demo-ruleForm" label-position="top" :inline="true">
        <el-form-item :label="$t(`page.users.userAddress.name`)" prop="realName" class="inline">
          <el-input v-model="formData.realName" :placeholder='$t(`page.users.userAddress.place`) +  $t(`page.users.userAddress.name`)'></el-input>
        </el-form-item>
        <el-form-item :label="$t(`page.users.userAddress.Email`)" prop="email" class="inline">
          <el-input v-model="formData.email" :disabled="isUserLoggedIn" :placeholder='$t(`page.users.userAddress.place`) +  $t(`page.users.userAddress.Email`)'></el-input>
        </el-form-item>
        <el-form-item :label="$t(`page.users.userAddress.phone`)" prop="phone" class="inline">
          <el-input v-model="formData.phone" :placeholder='$t(`page.users.userAddress.place`) +  $t(`page.users.userAddress.phone`)'></el-input>
        </el-form-item>
        <el-form-item :label="$t(`page.users.userAddress.postCode`)" prop="postCode" class="inline">
          <el-input v-model="formData.postCode" :placeholder='$t(`message.login.postCode`)'></el-input>
        </el-form-item>
        <el-form-item :label="$t(`page.users.userAddress.country`)" class="lang">
          <el-cascader
            ref="cascader"
            v-model="selectedRegion"
            :options="regionOptions"
            :props="cascaderProps"
            @change="handleRegionChange"
            :placeholder="$t('page.users.userAddress.placeRegion')"
            style="width: 100%;"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item :label="$t(`page.users.userAddress.address`)" prop="detail" class="lang">
          <el-input
            type="textarea"
            :rows="2"
            :placeholder='$t(`page.users.userAddress.place`) +  $t(`page.users.userAddress.address`)'
            v-model="formData.detail">
          </el-input>
        </el-form-item>
        <el-form-item prop="isDefault" class="lang">
          <el-checkbox v-model="formData.isDefault">{{$t(`page.users.userAddress.default`)}}</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button :loading="loadingBtn" type="primary" @click="submitForm('formData')">{{$t(`page.users.userAddress.save`)}}</el-button>
          <el-button @click="resetForm('formData')">{{$t(`page.goodsDetail.cancel`)}}</el-button>
        </el-form-item>
      </el-form>
    </div>
</template>

<script>
  import CountryCodeSelector from "@/components/countryCodeSelector.vue";
  import { getIpInfo } from '@/utils/order.js';
  import { isUserLoggedIn } from '@/utils/guestToken.js';
    export default {
        name: "addAddress",
      props: {
        formDatas: {
          type: Object,
          default: {}
        }
      },
        data() {
          return {
            isUserLoggedIn:isUserLoggedIn,
            loading: false,
            loadingBtn: false,
            countryName: '',
            formData: {
              country: '',
              countryCode: 86,
              email: '',
              realName: '',
              phone: '',
              detail: '',
              isDefault: false,
              postCode: ''
            },
            // 地区三级联动
            selectedRegion: [],
            regionOptions: [],
            cascaderProps: {
              lazy: true,
              lazyLoad: this.lazyLoadRegion,
              value: 'id',
              label: 'name',
              children: 'children'
            },
            rules: {
              realName:[
                { required: true, message: this.$t(`message.login.name`), trigger: 'blur' }
              ],
              email:[
                { required: true, message: this.$t(`message.login.emailEmpty`), trigger: 'blur' },
                { type: 'email', message: this.$t(`message.login.correctEmail`), trigger: ['blur', 'change'] }
              ],
              phone:[
                { required: true, message: this.$t(`message.login.emptyPhone`), trigger: 'blur' }
              ],
              detail:[
                { required: true, message: this.$t(`message.login.detail`), trigger: 'blur' }
              ],
              postCode: [
                {required: true, message: this.$t(`message.login.postCode`), trigger: 'blur'}
              ]
            }
          }
        },
      watch: {
        formDatas(n) {
          this.formData.realName = n.name
          this.formData.email = n.email
          this.formData.phone = n.phone
          this.formData.detail = n.address
          this.formData.isDefault = n.is_default == 1
          this.formData.postCode = n.code
          this.formData.id = n.id
          this.formData.countryCode = Number(n.countryCode)
          // 初始化地区选择器的值
          if (n.regions_id1 || n.regions_id2 || n.regions_id3) {
            this.selectedRegion = [
              n.regions_id1,
              n.regions_id2,
              n.regions_id3
            ].filter(id => id) // 过滤掉空值
          }
          
          this.loading = false
        }
      },
      components: {CountryCodeSelector},
      beforeCreate(){

      },
      mounted() {
        if(isUserLoggedIn){
          this.formData.email = JSON.parse(localStorage.getItem('userInfo') || '{}')?.email
        }
          if(this.formDatas.id){
            // 映射地址列表的字段到表单字段
            this.formData.realName = this.formDatas.name
            this.formData.email = this.formDatas.email
            this.formData.phone = this.formDatas.phone
            this.formData.detail = this.formDatas.address
            this.formData.isDefault = this.formDatas.is_default == 1
            this.formData.postCode = this.formDatas.code
            this.formData.id = this.formDatas.id
            this.formData.countryCode = Number(this.formDatas.countryCode)
            // 初始化地区选择器
            if (this.formDatas.regions_id1 || this.formDatas.regions_id2 || this.formDatas.regions_id3) {
              this.selectedRegion = [
                this.formDatas.regions_id1,
                this.formDatas.regions_id2,
                this.formDatas.regions_id3
              ].filter(id => id)
            }
          }else{
            // getIpInfo(this).then((res) => {
            //   if(!this.id){
            //     this.$set(this.formData,'country',res.data.country_name);
            //     this.$set(this.formData,'countryCode', Number(res.data.country_calling_code));
            //     this.$set(this.formData,'detail',res.data.region + ' ' + res.data.city);
            //   }
            //   this.loading = false
            // });
          }
      },
      methods: {
        /**
         * 懒加载地区数据
         */
        lazyLoadRegion(node, resolve) {
          const { level, value } = node;
          
          // 根据层级请求不同的数据
          // level 0: 省级, level 1: 市级, level 2: 区级
          const parentId = level === 0 ? 0 : value;
          
          this.$axios.post('/api/index/getRegionList', {
            id: parentId,
            level: level + 1
          }).then(res => {
            const nodes = res.data.map(item => ({
              id: item.id,
              name: item.name,
              leaf: level >= 2 // 第三级（区）没有子节点
            }));
            resolve(nodes);
          }).catch(err => {
            console.error('Failed to load region data:', err);
            resolve([]);
          });
        },
        
        /**
         * 地区选择变化
         */
        handleRegionChange(value) {
          console.log('Selected region:', value);
          // value 是一个数组 [省id, 市id, 区id]
          if (value && value.length > 0) {
            // 使用 cascader 的 getCheckedNodes 方法获取选中节点
            this.$nextTick(() => {
              const checkedNodes = this.$refs.cascader.getCheckedNodes();
              if (checkedNodes && checkedNodes.length > 0) {
                // 获取完整路径的标签
                const labels = checkedNodes[0].pathLabels;
                this.formData.country = labels.join(' ');
                console.log('Selected labels:', labels);
              }
            });
          } else {
            // 清空选择
            this.formData.country = '';
          }
        },
        
        countryInfo(obj){
          this.countryName = obj.name
          this.formData.country = obj.CNName
        },
        resetForm(formName) {
          this.$emit('closeAddressModal')
          this.$refs[formName].resetFields();
        },
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if (this.selectedRegion.length == 0) {
                this.$message.error(this.$t(`message.login.country`));
                return
              }
              const checkedNodes = this.$refs.cascader.getCheckedNodes();
              const regionsName = checkedNodes.length > 0 ? checkedNodes[0].pathLabels.join(' ') : this.formData.country;
              
              const data = {
                regions_id1: this.selectedRegion[0] || '', // 一级id
                regions_id2: this.selectedRegion[1] || '', // 二级id
                regions_id3: this.selectedRegion[2] || '', // 三级id
                regions: regionsName, // 三级名称拼接在一起
                address: this.formData.detail,// 详细地址
                email: this.formData.email, // 邮箱
                phone: this.formData.phone, // 电话
                name: this.formData.realName, // 联系人
                code: this.formData.postCode, // 邮政编码
                id: this.formData.id || undefined,
                is_default: this.formData.isDefault ? 1 : 0,
              }
              this.loadingBtn = true
              this.$axios.post('/api/center/addAddress', data).then(res => {
                this.$message.success(this.$t(`message.login.saveSU`));
                this.$emit('closeAddress')
                this.loadingBtn = false
              }).catch(err => {
                this.loadingBtn = false
              })
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
      }
    }
</script>

<style scoped lang="scss">
.lang{
  width: 100%;
}
.inline{
  width: 48%;
}
  .tel-container{
    width: 100%;
    height: 40px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 20px;
    .right_select {
      display: flex;
      align-items: center;

      .keyword {
        width: 62px;
        height: 16px;
        background: #EEEEEE;
        border-radius: 20px;
        font-size: 12px;
        font-family: ArialMT;
        color: #999999;
        line-height: 16px;
        text-align: center;
      }

      .search {
        width: 60px;
        height: 40px;
        background: #E93323;
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        color: #fff;
        margin-left: 11px;
      }
    }
  }
</style>
